/**
 * RoadwaysTabbedPanel - Panel izquierdo con pestañas para módulo Vialidades
 *
 * @version 1.0
 * @created 2026-02-27
 * @module roadways/components/panels
 *
 * @description
 * 2 pestañas: Segmentos Viales, Defectos Viales.
 * Usa BaseInventoryPanel para ambas pestañas (sistema nuevo).
 */

import { Route, Construction } from 'lucide-react';
import { useState } from 'react';
import { RoadDefectsPanel } from './RoadDefectsPanel';
import { RoadSegmentsPanel } from './RoadSegmentsPanel';
import '../../../../layouts/panels/LeftPanel/tabbed-left-panel.css';

type RoadwaysTabType = 'road-segments' | 'road-defects';

interface TabInfo {
  id: RoadwaysTabType;
  icon: React.ReactNode;
  tooltip: string;
  component: JSX.Element;
}

const TABS: TabInfo[] = [
  {
    id: 'road-segments',
    icon: <Route size={14} />,
    tooltip: 'Segmentos Viales\nRed vial con clasificación funcional, superficie y condición',
    component: <RoadSegmentsPanel />,
  },
  {
    id: 'road-defects',
    icon: <Construction size={14} />,
    tooltip: 'Defectos Viales\nReportes de baches, grietas y otros defectos físicos',
    component: <RoadDefectsPanel />,
  },
];

/**
 * Panel con pestañas para el módulo de Vialidades
 *
 * @remarks
 * Sigue el patrón estándar de todos los módulos:
 * - CSS compartido: tabbed-left-panel.css
 * - Iconos en tabs (lucide-react)
 * - Tooltips en hover
 * - Activa/Inactiva visual
 */
export function RoadwaysTabbedPanel(): JSX.Element {
  const [activeTab, setActiveTab] = useState<RoadwaysTabType>('road-segments');

  const activeTabInfo = TABS.find(tab => tab.id === activeTab);

  return (
    <div className="tabbed-left-panel">
      {/* Header con tabs */}
      <div className="tabs-header">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            title={tab.tooltip}
            aria-label={tab.tooltip.split('\n')[0]}
          >
            <span className="tab-icon">{tab.icon}</span>
          </button>
        ))}
      </div>

      {/* Contenido del tab activo */}
      <div className="tab-content">
        {activeTabInfo?.component}
      </div>
    </div>
  );
}
